import type { AsyncSequence } from "../types/AsyncSequence"
import type { GUID } from "../types/GUID"
import { MapAsync } from "../async/MapAsync"
import { JSONEncode } from "../encoding/JSONEncode"
import { StringHash } from "./StringHash"

/**
 * Computes SHA-256 hash of arbitrary JSON-serializable values.
 *
 * Serializes each value to JSON then computes hash. Deterministic for same input.
 *
 * @param stream - Async sequence of any JSON-serializable values
 * @returns Promise resolving to GUID hash
 *
 * @example
 * ```ts
 * import { GenericHash } from "@pdfking/tfunc"
 *
 * const hash1 = await GenericHash([{ name: "John", age: 30 }])
 * const hash2 = await GenericHash([{ age: 30, name: "John" }])
 * // hash1 === hash2 (same object, different key order)
 * ```
 */
export const GenericHash = async (stream: AsyncSequence<any>): Promise<GUID> =>
  StringHash(MapAsync(e => JSONEncode(e), stream))
